import React from 'react';
import 'twin.macro';
import { ArrowSmallRightIcon } from '@heroicons/react/20/solid';
import { NoSymbolIcon } from '@heroicons/react/24/outline';
import { RONote } from 'containers/CarnetsDeNotes/components/RONote';
import { NotationSystem } from 'types/notationSystem';
import { useTranslation } from 'react-i18next';

type Props = {
  prevNote?: number;
  nextNote?: number;
  notationSystem: NotationSystem;
};

export function DiffNote({ prevNote, nextNote, notationSystem }: Props) {
  const { t } = useTranslation(['carnet']);
  if (
    notationSystem.getNotationFromValue(prevNote || 0) ===
    notationSystem.getNotationFromValue(nextNote || 0)
  ) {
    return (
      <span tw="text-muted text-sm">
        {t('carnet:syncLivret.modal.gradeUnchanged')}
      </span>
    );
  }

  return (
    <div tw="flex justify-center">
      {prevNote ? (
        <RONote notationSystem={notationSystem} note={prevNote} tw="inline" />
      ) : (
        <NoSymbolIcon tw="inline w-5 h-5 p-0.5" />
      )}
      <ArrowSmallRightIcon tw="inline w-5 h-5" />
      {nextNote ? (
        <RONote notationSystem={notationSystem} note={nextNote} tw="inline" />
      ) : (
        <NoSymbolIcon tw="inline w-5 h-5 p-0.5" />
      )}
    </div>
  );
}
